import {useDispatch, useSelector} from "react-redux";
import mapStateToProps from "../../Components/BurgerMenusToggler/mapStateToProps";
import {setShowBurgerMenu} from "../../actions/ui";
import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

/**
 * хук для закрытия бургер-меню при смене URL.
 **/
export const useCloseBurgerMenu = () => {

    const {
        burgerMenuOpened
    } = useSelector(mapStateToProps)

    const dispatch = useDispatch()
    const location = useLocation();
    const prevLocation = useRef(location.pathname);

    useEffect(() => {

        if (burgerMenuOpened?.name && prevLocation.current !== location.pathname) {
            dispatch(setShowBurgerMenu(null))
        }

        prevLocation.current = location.pathname;

    }, [location?.pathname, burgerMenuOpened]);

}